import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'components.dataflowDrawer.title',
    defaultMessage: 'Dataflow',
    description: 'Title of the dataflow drawer',
  },
  feedback: {
    dataFlowFinished: {
      id: 'components.dataflowDrawer.feedback.dataFlowFinished',
      defaultMessage: 'Dataflow finished',
      description: 'notification when the dataflow is finished',
    },
    dataFlowFailed: {
      id: 'components.dataflowDrawer.feedback.dataFlowFailed',
      defaultMessage: 'Something went wrong while triggering the dataflow',
      description: 'notification when the dataflow is failed',
    },
    dataFlowUnmatched: {
      id: 'components.dataflowDrawer.feedback.dataFlowUnmatched',
      defaultMessage: "The criteria for this dataflow aren't met",
      description: "notification when the dataflow criteria aren't met",
    },
    noDataflows: {
      id: 'components.dataflowDrawer.feedback.noDataflows',
      defaultMessage: 'No dataflows found',
      description: 'notification when no dataflows are found',
    },
  },
};

export default defineMessages(translations);
